/**
 * Point d'entree de l'application Student
 */
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { studentConfig } from './app/student.config';
import { environment } from '../../environments/environment';
// Deja le bon module (projects/environments) : c'est celui que shared/ et
// fileReplacements utilisent. Ne pas repasser sur ./environments/.
import { loadRuntimeConfig } from '../../shared/src/lib/runtime-config';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

declare function gtag(a: string, b: string, c: any): void;
declare function initCrisp(crispID);

function AnalyzeDomain(env: any) {
    return env.urls.module;
}

function getLanguage() {
    if (localStorage.getItem('language') === null || localStorage.getItem('language') === 'undefined') {
        const browserLanguage = navigator.language.split('-')[0];
        if (environment.urls.languages.map(lang => lang === browserLanguage).length === 1) {
            return browserLanguage;
        }
        return environment.urls.defaultLanguage;
    }
    return localStorage.getItem('language');
}

loadRuntimeConfig(environment as any).then(() => {
    const module_actif = AnalyzeDomain(environment);
    void module_actif;

    localStorage.setItem('language', getLanguage());
    localStorage.setItem('site', environment.urls.module);
    localStorage.setItem('domaine', environment.urls.module);
    localStorage.setItem('default_role', environment.urls.default_role);

    registerLocaleData(localeFr);
    gtag('config', environment.urls.gtagID, { 'app_name': environment.urls.module });
    initCrisp(environment.urls.crispID);

    bootstrapApplication(AppComponent, studentConfig)
        .catch((err) => console.error(err));
});
